import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/search.png'


const _withScopeId = n => (_pushScopeId("data-v-12c3f7d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-com" }
const _hoisted_2 = { class: "meetting-wrap" }
const _hoisted_3 = { class: "meeting" }
const _hoisted_4 = { class: "hear-main" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"content-box\" data-v-12c3f7d2><img class=\"navtion-logo\" src=\"https://xiamenban.oss-cn-hangzhou.aliyuncs.com/guohui.png\" alt=\"\" data-v-12c3f7d2><div class=\"name-wrap\" data-v-12c3f7d2><div class=\"name\" data-v-12c3f7d2>四川省人民政府驻厦门办事处</div><div class=\"e-name\" data-v-12c3f7d2>Sichuan Provincial People&#39;s Government Office in Xiamen</div></div></div>", 1)
const _hoisted_6 = { class: "search-box" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "search" }, "搜索", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "searc-icon",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "header-nav" }
const _hoisted_11 = { class: "content" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "child-panel" }
const _hoisted_14 = ["onClick"]

import { ref, reactive } from "vue";
import moment from "moment";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import "element-plus/theme-chalk/el-message.css";
import "element-plus/theme-chalk/base.css";
import { getColumnList, getSettingList } from "../../request/api";

export default /*#__PURE__*/_defineComponent({
  __name: 'header1',
  setup(__props) {

moment.locale("zh-cn");
const router = useRouter();
let pid = router.currentRoute._value.query.level1Id;
const navList: Array<any> = ref([]);
// 获取栏目
let getColumnData = () => {
  getColumnList({}).then(res => {
    if (res.data.code == 200) {
      navList.value = res.data.data;
      // 插入一个首页
      navList.value.unshift({
        children: [],
        id: 0,
        index: 0,
        link_type: 1,
        link_url: "www.baidu.com",
        name: "首页",
        parent_id: 0
      });
      console.log(navList.value, "navList.value");
      if (pid) {
        navList.value.forEach((val, index) => {
          if (val.id == pid) {
            currentNav.value = index;
            console.log("wagagagaga", index);
          }
        });
      }
    }
  });
};
getColumnData();

// 获取官网设置
const baseConfig = ref({});
let getConfig = () => {
  getSettingList({}).then(res => {
    baseConfig.value = res.data.data;
    console.log(baseConfig.value, "baseConfig1111");
  });
};
getConfig();

let currentNav: Number = ref(0);

const changeNav = (index: Number, level1Id: Number, level2Id: number,
  link: string) => {
      if (link) {
    window.open(link);
  } else {
  console.log(index, level1Id, level2Id, 454545545);
  // 首页id为0
  if (level1Id == 0) {
    router.push("/");
  } else {
    router.push({
      path: "/pages/list/list",
      query: { level1Id: level1Id, level2Id: level2Id,current:0  }
    });
  }
  }

  currentNav.value = index;
};
let toLink = () => {
  window.open(baseConfig.value.header_link_url);
};

let keyWord = ref("");
let doSearch = () => {
 
  if (!keyWord.value) {
     console.log(keyWord.value,2322)
    // mess
    ElMessage({
      message: "请输入关键字",
      type: "error"
    });
  } else {
    router.push({
      path: "/pages/list/list",
      query: {
        keyWord: keyWord.value,current:0 
      }
    });
  }
};
let keydown = key => {
  if (key.code == "Enter") {
    doSearch();
  }
  console.log(key, "1231132");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, _toDisplayString(baseConfig.value.tip), 1),
        _withDirectives(_createElementVNode("div", null, _toDisplayString(_unref(moment)().format('YYYY年MM月DD日')) + "  " + _toDisplayString(_unref(moment)().format('dddd')), 513), [
          [_vShow, baseConfig.value.use_date]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          onKeydown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(keydown) && _unref(keydown)(...args))),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(keyWord) ? (keyWord).value = $event : keyWord = $event)),
          placeholder: "请输入您想要搜索的内容"
        }, null, 544), [
          [_vModelText, _unref(keyWord)]
        ]),
        _createElementVNode("div", {
          class: "button-wrap",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(doSearch) && _unref(doSearch)(...args)))
        }, _hoisted_9)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["nav-item", _unref(currentNav)==index?'activeNav':'']),
            onClick: ($event: any) => (changeNav(index,item.id,item?.children[0]?.id)),
            key: index
          }, [
            _createTextVNode(_toDisplayString(item.name) + " ", 1),
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (subItem, subindex) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "child-item",
                  onClick: _withModifiers(($event: any) => (changeNav(index,item.id,subItem.id,subItem.link_url)), ["stop"]),
                  key: subItem.name
                }, _toDisplayString(subItem.name), 9, _hoisted_14))
              }), 128))
            ])
          ], 10, _hoisted_12))
        }), 128))
      ])
    ])
  ]))
}
}

})